<!--
  No reserved empty space, and still no jump: the suggestion sits in the status
  row, which is always as tall as the button, and every hint fits one line. The
  verdict column is then as tall as the preview beside it.
-->
<div class="flex flex-col gap-4 rounded-lg border p-4 sm:flex-row sm:items-center">
  <!-- Preview: the colours as the voucher plugin uses them -->
  <div
    class="flex shrink-0 flex-col items-start gap-1 rounded-md px-4 py-3 sm:w-52"
    aria-hidden="true"
    [class]="valid() ? '' : 'text-muted-foreground border border-dashed'"
    [style.background-color]="valid() ? background() : null"
    [style.color]="valid() ? text() : null">
    <span class="text-sm font-semibold">Gutschein kaufen</span>
    <span class="text-xs">Verschenke Freude ab 10 €</span>
  </div>

  <!-- Verdict: announced when the colours change -->
  <div class="min-w-0 flex-1 space-y-2" role="status" aria-live="polite">
    <div class="flex min-h-8 flex-wrap items-center justify-between gap-2">
      <p class="flex items-center gap-1.5 text-sm font-medium" [class]="copy().tone">
        <ng-icon [name]="copy().icon" size="16" class="shrink-0" />
        {{ copy().title }}
      </p>
      @if (showSuggestion()) {
        <button
          hlmBtn
          type="button"
          variant="outline"
          size="sm"
          [attr.aria-label]="
            suggestion().label +
            ' als Schriftfarbe verwenden, Kontrast ' +
            formatRatio(suggestion().ratio)
          "
          (click)="applySuggestion.emit(suggestion().color)">
          <span
            class="size-3.5 rounded-full border"
            aria-hidden="true"
            [style.background-color]="suggestion().color"></span>
          {{ suggestion().label }} verwenden
          <span class="text-muted-foreground tabular-nums">{{
            formatRatio(suggestion().ratio)
          }}</span>
        </button>
      }
    </div>
    <p class="text-muted-foreground text-xs">
      @if (valid()) {
        <span class="tabular-nums">Kontrast {{ formatRatio(ratio()) }}</span> ·
      }
      {{ copy().description }}
    </p>
  </div>
</div>
